







import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import ModalError from '@/shared/components/ModalError/ModalError.vue';

import { createCaptcha } from '@/helpers/captcha';
import { addScriptMercadoPago } from '@/helpers/dom';
import { EErrorExhibition, EErrorScope } from '@/helpers/enums';

import { ITraceableError } from '@/interfaces/Error';

const ErrorModule = namespace('App/Error');
const CustomerModule = namespace('App/Customer');
const InteractEventTrackerModule = namespace('App/InteractEventTracker');

declare global {
  // eslint-disable-next-line @typescript-eslint/interface-name-prefix
  interface Window {
    MercadoPago: any;
    mp: any;
    koin: any;
    GetKoinFraudID: any,
  }
}

@Component({
  components: {
    ModalError,
  },
})
export default class App extends Vue {
  @CustomerModule.Getter('isLogged')
  private customerIsLogged: boolean;

  @ErrorModule.Getter('errorsByExhibitionAndScope')
  private errorsByExhibitionAndScope: Function;

  @InteractEventTrackerModule.Action
  private initInteractBehavior: Function;

  private get error(): ITraceableError {
    const errors = this.errorsByExhibitionAndScope(EErrorExhibition.modal, [
      EErrorScope.payment,
      EErrorScope.global
    ]);

    const error = errors[errors.length - 1];

    return error;
  }

  private get device() {
    let devices = [];

    if (navigator.userAgent.indexOf('iPhone') > -1) {
      devices.push('iPhone');
    }

    return devices.join(' ');
  }

  @Watch('customerIsLogged')
  whenCustomerIsLogged(customerIsLogged: boolean) {
    if (customerIsLogged) {
      createCaptcha().catch((err: any) => err);
    }
  }

  mounted() {
    this.initInteractBehavior();
    addScriptMercadoPago();
  }
}
